import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import {
  CategoryPage,
  GetCategoryPagesRequest,
  GetCategoryPagesResponse,
  SaveCategoryPageRequest,
  SaveCategoryPageResponse,
} from '@models'

@Injectable({
  providedIn: 'root',
})
export class CategoryPageService {
  private readonly baseUrl = `${environment.api.baseUrl}/product-structure/v1/category-pages`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetCategoryPagesRequest): Promise<GetCategoryPagesResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.text) httpParams = httpParams.set('text', params.text)

      if (params.categoryId) httpParams = httpParams.set('categoryId', params.categoryId)

      if (params.status !== undefined && params.status !== '') {
        httpParams = httpParams.set('status', params.status)
      }

      const hasStartDate = !!params.startDate
      const hasEndDate = !!params.endDate

      if (hasStartDate && hasEndDate) {
        httpParams = httpParams.set('startDate', params.startDate!).set('endDate', params.endDate!)
      }
    }

    const response = await firstValueFrom(this.http.get<GetCategoryPagesResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<CategoryPage> {
    const response = await firstValueFrom(this.http.get<CategoryPage>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveCategoryPageRequest): Promise<SaveCategoryPageResponse> {
    const response = await firstValueFrom(this.http.post<SaveCategoryPageResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveCategoryPageRequest): Promise<SaveCategoryPageResponse> {
    const response = await firstValueFrom(this.http.put<SaveCategoryPageResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
